import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { isTokenExpired } from '@services/auth.utils';
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getToken();
  const router = inject(Router);

  if (token) {
    if (isTokenExpired(token)) {
      // console.warn('Token expired');
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('userSessionData');
      router.navigate(['/login']);
      return throwError(() => new Error('Token expired'));
    }
    let userData = JSON.parse(localStorage.getItem('userSessionData'));
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-User-Id': String(getUserId()),
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401 || error.status === 403) {
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('userSessionData');
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
function getUserId(): string {
  const id = JSON.parse(localStorage.getItem('userSessionData'))?.id;
  return id ?? '';
}
function getToken(): string | null {
  if (typeof window !== 'undefined' && localStorage) {
    return localStorage.getItem('jwtToken');
  }
  return null;
}
